module.exports = __webpack_public_path__ + "img/folder.4302c527.svg";